import { Link } from "react-router-dom";
import { getQueryString } from "../../../common";
import { FrontYardLivingAreaFormV2 } from "./";

const ComplexList = (props) => {
  const { frontYards, livingAreas, queryParams, history } = props;

  return (<>
    <FrontYardLivingAreaFormV2
      frontYards={frontYards}
      livingAreas={livingAreas}
      selectedFrontYardId={queryParams.frontYardId}
      selectedLivingAreaId={queryParams.livingAreaId}
      onChangeFrontYard={(data) => history.push(`?${getQueryString(data)}`)}
      onChangeLivingArea={(data) => history.push(`?${getQueryString(data)}`)} />

    <table className="table table-sm">
      <thead>
        <tr>
          <th style={{ width: "20%" }}>FrontYard</th>
          <th style={{ width: "10%" }}>LivingArea</th>
          <th>Name</th>
          <th style={{ width: "15%" }}>Age</th>
          <th style={{ width: "15%" }}>Headcount</th>
        </tr>
      </thead>
      <tbody>
        {props.complexes.map(v => (<ComplexListItem key={v.id} item={v} />))}
      </tbody>
    </table>
  </>);
};

const ComplexListItem = (props) => {
  const { item } = props;
  return (
    <tr>
      <td><Link to={`/realestate/frontyard/${item.frontYardId}`}>{item.frontYardName}</Link></td>
      <td><Link to={`/realestate/livingarea/${item.livingAreaId}`}>{item.livingAreaName}</Link></td>
      <td><Link to={`/realestate/complex/${item.id}`}>{item.name}</Link></td>
      <td>{item.approvedYear}({item.age}년차)</td>
      <td>{item.totalHouseholdCount.toLocaleString('ko-KR')}세대</td>
      <td></td>
    </tr>
  )
}

export { ComplexList };
